module.exports = __webpack_public_path__ + "static/media/D657EchoStNW_2018-06-25_189.e29dc90f.jpg";